import de from "ajv-i18n/localize/de";
import en from "ajv-i18n/localize/en";
import i18n from "@/plugins/i18n";

/**
 * Helper class to get translation for
 * third party libraries
 */
export class TranslationHelper {
  /**
   * Sadly CKeditor5 does not support dynamic
   * translations yet. The lang must be defined on build time :(
   * https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/frameworks/vuejs-v3.html#localization
   * https://ckeditor.com/docs/ckeditor5/latest/framework/guides/deep-dive/ui/localization.html#known-limitations
   */
  static getCkEditorTranslations(): void {
    throw new Error(
      "Ckeditor does not support dynamic lang changing. Sad face"
    );
  }

  /**
   * get the ajv translations used
   * in the vue-form-schema-json
   */
  static getAjvTranslations(): unknown {
    const lang = i18n.locale;
    if (lang === "de") {
      return de;
    }
    return en;
  }
}
